<template>
    <div style="padding:10px;">
        <ion-chip @click="openPopover($event, 1)" slot="start">{{ labelName('state') }} <ion-icon color="primary"
                :icon="caretDown"></ion-icon></ion-chip>
        <ion-chip v-if="state!=''" @click="openPopover($event, 2)" slot="start">{{ labelName('county') }} <ion-icon
                color="primary" :icon="caretDown"></ion-icon></ion-chip>
        <ion-chip @click="openPopover($event, 3)" slot="start">{{ labelName('hashtag') }} <ion-icon color="primary"
                :icon="caretDown"></ion-icon></ion-chip>
        <ion-chip style="float:right;" color="clear" @click="openInfoPopover($event)" ><ion-icon
                :icon="helpCircleOutline"></ion-icon></ion-chip>
    </div>
    <ion-popover :is-open="popoverOpen" :event="event" @didDismiss="popoverOpen = false">
        <div v-if="selectState">
            <ion-list v-for="(stateName, stateNameIndex) in electionStates" :key="stateNameIndex">
                <ion-item detail="false" button @click="chooseState(stateName)">{{ stateName }}</ion-item>
            </ion-list>
        </div>
        <div v-if="selectCounty">
            <ion-list v-for="(countyName, countyNameIndex) in electionCounties" :key="countyNameIndex">
                <ion-item detail="false" button @click="chooseCounty(countyName)">{{ countyName }}</ion-item>
            </ion-list>
        </div>
        <div v-if="selectHashTag">
            <ion-list v-for="(hashtagName, hashtagNameIndex) in hashtagNames" :key="hashtagNameIndex">
                <ion-item detail="false" button @click="chooseHashtag(hashtagName)">{{ hashtagName }}</ion-item>
            </ion-list>
        </div>
    </ion-popover>
    <ion-popover :is-open="popoverOpenInfo" :event="eventInfo" @didDismiss="popoverOpenInfo = false">
        <ion-content class="ion-padding">
            <h4>Hashtag Definitions</h4>
            <p v-for="(hashtagInfo, hashtagIndex) in showHashtagInfo" :key="hashtagIndex"><strong>#{{ hashtagIndex
                    }}</strong>
                {{ hashtagInfo }}</p>
        </ion-content>
    </ion-popover>
</template>

<script>
import { IonChip, IonIcon, IonPopover, IonList, IonItem, IonContent } from '@ionic/vue';
import { caretDown, helpCircleOutline } from 'ionicons/icons';

export default {
    name: 'ElectionFilter',
    components: { IonChip, IonIcon, IonPopover, IonList, IonItem, IonContent },
    emits: ['update:refreshFeed'],
    props: {
        refreshFeed: { Boolean, default: false }
    },
    setup() {
        return {
            caretDown,
            helpCircleOutline
        }
    },
    data() {
        return {
            popoverOpen: false,
            event: null,
            popoverOpenInfo: false,
            eventInfo: null,
            county: '',
            state: '',
            hashtag: '',
            hashtagNames: ['All Hashtags','MachinesOnline','MachinesDown','ViolationofLaw','BallotsVoteTally','VoterRolls',
      'BallotTrafficking', 'VotingSystems','PollBooks','ChainofCustody','VoterHistory',
      'Certification','Racketeering','Obstruction','DestructionofRecords',
      'DropBoxes','SpecialVotingCenters','FinancialTransactions','ViolationofProcedures'],
            selectState: false,
            selectCounty: false,
            selectHashTag: false
        };
    },
    mounted(){
        if(this.$store.state.pikstream.electionStates.length==0){
            this.$store.dispatch("pikstream/getStateData");
        }
    },
    methods: {
        getCounty(){
            if(this.state!=''){
                this.$store.dispatch("pikstream/getCountyData", { state: this.state });
            }
        },
        chooseState(stateName){
            if(stateName=='All States'){
                this.state = '';
                this.county = '';
            }else if(stateName!=this.state && this.state!=''){
                this.county = '';
                this.state=stateName; 
            }else{
                this.state=stateName; 
            }
            this.popoverOpen = false;
            this.$store.commit('pikstream/setElectionFilter', [this.state, this.county, this.hashtag]);
            this.$emit('update:refreshFeed', true);
            this.getCounty();
        },
        chooseCounty(countyName){
            if(countyName=='All Counties') countyName = '';
            this.county=countyName; 
            this.popoverOpen = false;
            this.$store.commit('pikstream/setElectionFilter', [this.state, this.county, this.hashtag]);
            this.$emit('update:refreshFeed', true);
        },
        chooseHashtag(hashtagName){
            if(hashtagName=='All Hashtags') hashtagName = '';
            this.hashtag=hashtagName; 
            this.popoverOpen = false;
            this.$store.commit('pikstream/setElectionFilter', [this.state, this.county, this.hashtag]);
            this.$emit('update:refreshFeed', true);
        },
        openPopover(e, type) {
            this.event = e;
            this.popoverOpen = true;
            this.selectCounty = false;
            this.selectState = false;
            this.selectHashTag = false;
            switch (type) {
                case 1:
                    this.selectState=true;
                    break;
                case 2:
                    this.selectCounty=true;
                    break;
                case 3:
                    this.selectHashTag=true;
                    break;
                default:
                    break;
            }
        },
        labelName(type){
            let label = '';
            if(type=='state'){
                label = "State";
                if(this.state!='') label = this.state;
            }
            if(type=='county'){
                label = "County";
                if(this.county!='') label = this.county;
            }
            if(type=='hashtag'){
                label = "Hashtag";
                if(this.hashtag!='') label = this.hashtag;
            }
            return label;
        },
        openInfoPopover(e) {
            this.eventInfo = e;
            this.popoverOpenInfo = true;
        },
    },
    computed: {
        electionStates() {
            if (this.$store.state.pikstream.electionStates != null) {
                let electionStates = this.$store.state.pikstream.electionStates;
                electionStates.unshift('All States');
                return electionStates;
            }
            return [];
        },
        electionCounties() {
            if (this.$store.state.pikstream.electionCounties != null) {
                let electionCounties = this.$store.state.pikstream.electionCounties;
                electionCounties.unshift('All Counties');
                return electionCounties;
            }
            return [];
        },
        showHashtagInfo() {
            let data = {
                'Ballots':	'Any anomaly pertaining to ballots including but not limited to paper specifications, marker specifications, printers, lot control, candidate listings, or security.',
                'BallotTrafficking':	'Information pertaining to ballot factories, ballot distribution centers, mules, and the organizations involved.',
                'Certification':	'Machine certification issues pertaining federal, state, and local requirements compliance as well as pre-election logic and accuracy testing issues.',
                'ChainofCustody':	'Any breaks in the digital and/or physical election record chain of custody',
                'DestructionofRecords':	'Any incidents involving attempted or actual destruction of digital and/or physical election records',
                'DropBoxes':	'Anomalies pertaining to the use of drop boxes including but not limited to surveillance records availability, multiple ballot drops, location anomalies, and pickup/dropoff anomalies.',
                'ElectionFraud':	'Any evidence of illegal interference with the process of conducting an election.',
                'FinancialTransactions':	'Any evidence of suspicious financial relationships between individuals or organizations associated with election fraud.',
                'MachinesDown':	'Any incidents featuring machine errors',
                'MachinesOnline':	'Any evidence that suggests that election systems are connected to external systems',
                'Obstruction':	'Any attempts to interfere with the lawful oversight of election processes',
                'PollBooks':	'Any anomalies specific to poll books',
                'Racketeering':	'Any indications of a pattern of illegal activities conducted as part of an organized effort.',
                'SpecialVotingCenters':	'Any indications of voting centers not disclosed to the general public.',
                'ViolationofProcedures':	'Any evidence of failure to comply with official election procedures',
                'ViolationofLaw':	'Any evidence of failure to comply with statutes',
                'VoterHistory':	'Any anomalies specific to whether or not an individual actually voted as well as their voting method.',
                'VoterRolls':	'Any anomalies specific to whether or not an individual listed as eligible to vote is asctually legally eligible to vote',
                'VoteTally': 'Any evidence of vote tally anomalies',
                'VotingSystems': 'Any example of machines which tally votes not being subject to oversight by general public or displaying behavior that is not compliant with government specifications.'
            }
            return data;
            }
    }
}
</script>